export default __webpack_public_path__ + "static/heroupdatecommunity-5ec86a84fd19afa2732e53da33b40498.jpg";